import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-final-form';
import { Redirect } from 'react-router-dom';
import { loadBanks } from '../../Transfer/actions';
import { changeForm, paymentConfirm, paymentNotSupported } from '../actions';
import PaymentFormStep1 from './Form1';
import PaymentFormStep2 from './Form2';

class ZwalletPayment extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(loadBanks());
  }

  __submitStep1(data) {
    const { dispatch } = this.props;
    dispatch(changeForm(data));
  }

  __submitStep2(data) {
    const { form, supported, dispatch } = this.props;

    if (supported) {
      dispatch(paymentConfirm({ protocol: form.protocol, dueDate: form.dueDate }))
    } else {
      dispatch(paymentNotSupported(data))
    }
  }

  render() {
    const { form2, redirect } = this.props;

    if (redirect) {
      return <Redirect to="/zwallet" />
    }

    return (
      <Fragment>
        <div className="header bg-gradient-danger py-6">
          <div className="container-fluid">
            <div className="header-body">
              <div className="row align-items-center py-4">
                <div className="col-lg-6 col-7">
                  <h6 className="h2 text-white d-inline-block mb-0">Pagamentos Zwallet</h6>
                </div>
              </div> 
            </div>
          </div>
        </div>
        <div className="container-fluid mt--6">
          <div className="row">
            <div className="col">
              <div className="card">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col-12">
                      <h3 className="mb-0">Formulário de Pagamento</h3>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {!form2 ?
                    <Form
                      onSubmit={(data) => this.__submitStep1(data)}
                      initialValues={{
                        barcode: this.props.form.barcode || "",
                        description: this.props.form.description || ""
                      }}
                      render={props => <PaymentFormStep1 {...props} />}
                    />
                  :
                    <Form
                      onSubmit={(data) => this.__submitStep2(data)}
                      initialValues={{
                        barcode: this.props.form.barcode || "",
                        description: this.props.form.description || "",
                        bank: this.props.form.bank || '001',
                        dueDate: this.props.form.dueDate || "",
                        amount: this.props.form.amount || ""
                      }}
                      render={props => <PaymentFormStep2 formProps={props} {...this.props} />}
                    /> 
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
    </Fragment>
    );
  }
}

const mapStateToProps = state => {
    const { zwallet } = state;
    const form = zwallet.payment.form;
    const form2 = zwallet.payment.form2;
    const redirect = zwallet.payment.redirect;
    const supported = zwallet.payment.supported;
    const banks = zwallet.payment.banks;

    return { form, banks, form2, redirect, supported }
}

export default connect(mapStateToProps)(ZwalletPayment);


// WEBPACK FOOTER //
// ./src/ZWallet/Payment/components/Payment.js